import { Pipe, PipeTransform } from '@angular/core';
import {
  CommissioningGasDeviceTypeConstant,
  CommissioningPowerDeviceTypeConstant,
  CommissioningPowerHeatingUseConstant,
  CommissioningPowerHeatSourceTypeConstant,
  CommissioningPowerLocationTypeConstant,
  CommissioningPowerObjectTypeTypeConstant,
  CommissioningPowerOperationalModeTypeConstant,
  CommissioningPowerPumpTypeTypeConstant
} from '@bo-client/activation-management/shared/commissioning-constans';

import {
  FeedingPlantTypeConst,
  GridRegistrationStatusEnum,
  GridRegistrationTypeEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { ProducerModel } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { StorageModel } from '@bo-client/activation-management/grid-registration/model/storage.model';
import {
  CommissioningActionType,
  CommissioningDistrictHeatActionTypeEnum,
  CommissioningGasActionTypeEnum,
  CommissioningPowerActionTypeEnum,
  CommissioningPowerMeterTypeConstant,
  CommissioningWaterActionTypeEnum
} from '@bo-client/activation-management/commissioning/forms/commissioning-data-enum';
import { PVModuleModel } from '@bo-client/activation-management/grid-registration/model/pv-module.model';
import { ActionDtoModel } from '@bo-client/activation-management/shared/models/actionModel';
import { CommissioningPowerMeterType } from '@bo-client/activation-management/shared/models/commissioningModel';
import { MetaService } from '@bo-client/core/api/meta-service';
import { map } from 'rxjs';

@Pipe({
  name: 'devicePowerTypePipe'
})
export class DevicePowerTypePipePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerDeviceTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx !== -1) {
      textFound = CommissioningPowerDeviceTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerMeterTypeDisplayNamePipe'
})
export class PowerMeterTypeDisplayNamePipe implements PipeTransform {
  transform(value: string) {
    const idx = CommissioningPowerMeterTypeConstant.findIndex((ele) => ele.value === value);
    let textFound = value;
    if (idx !== -1) {
      textFound = CommissioningPowerMeterTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'commissioningPowerObjectTypePipe'
})
export class CommissioningPowerObjectTypePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerObjectTypeTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerObjectTypeTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'deviceGasTypePipe'
})
export class DeviceGasTypePipePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningGasDeviceTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningGasDeviceTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerGenerationSourcePipe'
})
export class PowerGenerationSourcePipe implements PipeTransform {
  constructor(public gridRegistrationService: GridRegistrationRequestService) {}

  transform(value: any) {
    const idx = this.gridRegistrationService.PowerGenerationSourceType.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = this.gridRegistrationService.PowerGenerationSourceType[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'feedingPlantTypeConstPipe'
})
export class FeedingPlantTypeConstPipe implements PipeTransform {
  transform(value: any) {
    const idx = FeedingPlantTypeConst.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = FeedingPlantTypeConst[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'phasesTypePipe'
})
export class PhasesTypePipe implements PipeTransform {
  constructor(public gridRegistrationService: GridRegistrationRequestService) {}

  transform(value: any) {
    const idx = this.gridRegistrationService.phasesType.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = this.gridRegistrationService.phasesType[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'filterCurrentPowerTypePipe'
})
export class FilterCurrentPowerTypePipe implements PipeTransform {
  transform(powerCurrentPowerTypes: any[], meterType: any) {
    if (meterType && meterType == CommissioningPowerMeterType.TransformerMeter) {
      return powerCurrentPowerTypes.filter((x) => x.value == 'smaller_5A' || x.value == 'smaller_1A');
    } else {
      return powerCurrentPowerTypes.filter((x) => x.value != 'smaller_5A' || x.value == 'smaller_1A');
    }
  }
}

@Pipe({
  name: 'filterFuseAmpTypeByOperationModePipe'
})
export class FilterFuseAmpTypeByOperationModePipe implements PipeTransform {
  transform(
    powerCurrentPowerTypes: {
      value: number;
      displayName: string;
    }[],
    operationMode: 'continuousOperation' | 'intermittentOperation'
  ): {
    value: number;
    displayName: string;
  }[] {
    return powerCurrentPowerTypes.filter((x) => {
      return operationMode === 'intermittentOperation' || x.value < 60;
    });
  }
}

@Pipe({
  name: 'actionTypePipe'
})
export class ActionTypePipe implements PipeTransform {
  transform(value: number | string, areaType: string, fieldName: 'displayName' | 'comment') {
    let arrayEnum: CommissioningActionType[] = [];
    switch (areaType?.toLowerCase()) {
      case 'gas':
        arrayEnum = CommissioningGasActionTypeEnum;
        break;
      case 'power':
        arrayEnum = CommissioningPowerActionTypeEnum;
        break;
      case 'districtheat':
        arrayEnum = CommissioningDistrictHeatActionTypeEnum;
        break;
      case 'water':
        arrayEnum = CommissioningWaterActionTypeEnum;
        break;
    }

    const idx = arrayEnum.findIndex((ele) => ele.value == value);
    let textFound = '--';
    if (idx != -1) {
      switch (fieldName) {
        case 'displayName':
          textFound = arrayEnum[idx].displayName;
          break;
        case 'comment':
          textFound = arrayEnum[idx].comment;
          break;
      }
    }
    return textFound;
  }
}

@Pipe({
  name: 'totalPowerProducersPipe'
})
export class TotalPowerProducersPipe implements PipeTransform {
  transform(value: any, producersList: ProducerModel[]) {
    let totalPower = 0;

    producersList.forEach((ele) => (totalPower = totalPower + ele.acActivePowerMax * ele.count));
    return totalPower;
  }
}

@Pipe({
  name: 'totalApparentPowerProducersPipe'
})
export class TotalApparentPowerProducersPipe implements PipeTransform {
  transform(value: any, producersList: ProducerModel[]) {
    let totalPower = 0;

    producersList.forEach((ele) => (totalPower = totalPower + ele.acApparentPowerMax * ele.count));
    return totalPower;
  }
}

@Pipe({
  name: 'totalPowerPvModulePipe'
})
export class TotalPowerPvModulePipe implements PipeTransform {
  transform(item: any, pvModulesList: PVModuleModel[]) {
    let totalPower = 0;
    pvModulesList.forEach((ele) => (totalPower = totalPower + ele.modulePowerWatt * ele.count));
    return totalPower / 1000;
  }
}

@Pipe({
  name: 'totalPowerStoragePipe'
})
export class TotalPowerStoragePipe implements PipeTransform {
  transform(value: any, storageList: StorageModel[]) {
    let totalPower = 0;

    storageList.forEach((ele) => (totalPower = totalPower + ele.usableCapacity * ele.count));
    return totalPower;
  }
}

@Pipe({
  name: 'powerLocationTypePipe'
})
export class PowerLocationTypePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerLocationTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerLocationTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerPumpTypePipe'
})
export class PowerPumpTypePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerPumpTypeTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerPumpTypeTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerHeatingUsePipe'
})
export class PowerHeatingUsePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerHeatingUseConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerHeatingUseConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerOperationalModeTypePipe'
})
export class PowerOperationalModeTypePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerOperationalModeTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerOperationalModeTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'powerHeatSourceTypePipe'
})
export class PowerHeatSourceTypePipe implements PipeTransform {
  transform(value: any) {
    const idx = CommissioningPowerHeatSourceTypeConstant.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = CommissioningPowerHeatSourceTypeConstant[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'connectedPhasenPipe'
})
export class ConnectedPhasenPipe implements PipeTransform {
  constructor(public gridRegistrationService: GridRegistrationRequestService) {}

  transform(connectedPhasen: any) {
    if (connectedPhasen) {
      const idx = this.gridRegistrationService.connectedPhasesType.findIndex(
        (x) => x.value == connectedPhasen
      );
      if (idx != -1) {
        return this.gridRegistrationService.connectedPhasesType[idx].displayName;
      }
    }
    return '---';
  }
}

@Pipe({
  name: 'hasInvalidExistingDevicesPipe'
})
export class HasInvalidExistingDevicesPipe implements PipeTransform {
  transform(actions: ActionDtoModel[]) {
    if (!actions || actions.length === 0) {
      return '';
    }

    let isValid = false;
    let isNonValid = false;

    for (const action of actions) {
      for (const device of action.devices) {
        const { gridRegistration } = device;
        if (!gridRegistration || !gridRegistration.gridRegistrationType || !gridRegistration.state) {
          continue;
        }

        const { gridRegistrationType, state } = gridRegistration;

        const isFeeder = gridRegistrationType === GridRegistrationTypeEnum.Feeder;
        const isApproved = state === GridRegistrationStatusEnum.Approved;
        const isPlacedInServiceConfirmation =
          state === GridRegistrationStatusEnum.PlacedInServiceConfirmation;

        if ((isFeeder && !isPlacedInServiceConfirmation) || (!isFeeder && !isApproved)) {
          isNonValid = true;
        } else {
          isValid = true;
        }
      }
    }

    if (isValid && !isNonValid) {
      return 'Freigegeben';
    } else if (!isValid && isNonValid) {
      return 'Ausstehend';
    }

    return '';
  }
}
